export class ChoiceAttempts {
    parent;
    constructor(parent) {
        this.parent = parent;
    }
    get question() {
        return this.parent;
    }
    get latestFailedAttempt() {
        return this.question.selections.find(selection => selection.isFailedAttempt);
    }
    get dateOfLatestFailedAttempt() {
        if (this.latestFailedAttempt)
            return this.latestFailedAttempt.selectionDate;
        return undefined;
    }
    get numberOfFailedAttempts() {
        return this.question.selections.filter(selection => selection.isFailedAttempt).length;
    }
    get failedOptionNumber() {
        if (!this.latestFailedAttempt)
            return 0;
        return this.latestFailedAttempt.selectedOption.optionNumber;
    }
}
